import { inject, Injectable } from '@angular/core';
import { NotificationsFacade } from '@p2p/notifications/domain';

@Injectable()
export class NotificationsApiService {
    private readonly notificationsFacade = inject(NotificationsFacade);

    readonly unreadCount$ = this.notificationsFacade.unreadCount$;

    loadUnreadCount(): void {
        this.notificationsFacade.loadUnreadCount();
    }

    startUnreadCountPolling(): void {
        this.notificationsFacade.startUnreadCountPolling();
    }
}
